import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { gql, useApolloClient, useReactiveVar } from "@apollo/client";
import TitleBar, { WithfriendsAction } from "./WithfriendsTitleBar";
import SubscriptionBenefit from "./SubscriptionBenefit";
import { SubscriptionBenefitPreferCacheFragmentDoc, WelcomeGiftBenefitPreferCacheFragmentDoc } from "../types";
import { currentSubscriptionBenefitVar, currentBusinessIdVar, dummyFunc } from "../helpers/client";
import { useBenefitMembershipTierInfoQuery, } from "../types";
import { useAppBridge } from "@shopify/app-bridge-react";
import { Redirect } from "@shopify/app-bridge/actions";
// @ts-ignore
import { useNavigate, useMatch } from "react-router-dom";
gql `
query BenefitMembershipTierInfo($id: ID!) {
  benefit(id: $id){
    ... on SubscriptionBenefit {
      id
      name
      membershipTiers {
        id
        name
      }
      ${SubscriptionBenefitPreferCacheFragmentDoc}
    }

    ... on WelcomeGiftBenefit {
      id
      name
      membershipTiers {
        id
        name
      }
      ${WelcomeGiftBenefitPreferCacheFragmentDoc}
    }
  }
}
`;
const EditSubscriptionBenefitScreen = ({ useSyncShopifyDataMutation = dummyFunc, isWelcomeGift = false }) => {
    var _a, _b;
    // TODO - can't seem to abstract this out without React crashing, so we gotta copy and paste it into any relevant file
    let app, redirect = null;
    let navigate = useNavigate();
    try {
        app = useAppBridge();
        redirect = Redirect.create(app);
    }
    catch (e) { }
    const VisitLink = (url) => {
        if (redirect) {
            return redirect.dispatch(Redirect.Action.APP, url);
        }
        else
            return navigate(url);
    };
    // TODO - end
    const currentBusinessId = useReactiveVar(currentBusinessIdVar);
    const client = useApolloClient();
    const isReady = () => {
        const tiers = client.readFragment({
            id: `Business:${currentBusinessId}`,
            fragment: gql `
        fragment SaveMemberships2 on Business {
          membershipTiers(kind:Live) {
            id
            name
            defaultMode
            overridePlatformProductSync
            plans {
              kind
              price {
                amount
              }
            }
            discounts {
              scope
              percentage
              guests
            }
            welcomeGift {
              __typename
              id
              name
              products {
                id
                name
                platformId
                platformName
                platformVariantsOnlyMode
                variants {
                  id
                  description
                  additionalCost {
                    amount
                  }
                  platformName
                  platformId
                }
              }
              variants {
                id
                description
                additionalCost {
                  amount
                }
                platformName
                platformId
              }
            }
            benefits {
              __typename
              id
              name
              ...on SubscriptionBenefit {
                delivery
                nextShipmentDate
                isAddonOnly
                shippingFrequency {
                  number
                  period
                }
                deliveryFrequency
                firstShipmentDelay
                curationPreferOverstock
                curationMatchMode
                products {
                  id
                  name
                  platformId
                  platformName
                  platformVariantsOnlyMode
                  curationValue
                  curationExcludeProducts
                  curationCollections
                  variants {
                    id
                    description
                    additionalCost {
                      amount
                    }
                    platformName
                    platformId
                    curationExcludeProducts
                    curationIncludeVariants
                    curationSearchTerms
                    curationStatus
                  }
                }
                variants {
                  id
                  description
                  additionalCost {
                    amount
                  }
                  platformName
                  platformId
                }
                addons {
                  id
                  description
                  applyDiscount
                  dontRollOver
                  platformId
                  platformName
                  additionalCost {
                    amount
                  }
                }
              }
            }
          }
        }
      `,
        });
        return !!tiers;
    };
    if (!isReady()) {
        VisitLink("/memberships");
        return _jsxs("p", { children: ["Redirecting to ", _jsx("a", { style: { textDecoration: "underline" }, onClick: () => VisitLink("/memberships"), children: "membership tiers" }), " ..."] });
    }
    const matchFragment = isWelcomeGift ? "welcome" : "subscription";
    const match = useMatch(`/memberships/:id/${matchFragment}/:benefitId`);
    const membershipId = match.params.id;
    const benefitId = match.params.benefitId;
    // KGAUDIT - why cachefirst?
    const { data } = useBenefitMembershipTierInfoQuery({
        fetchPolicy: "cache-first",
        variables: { id: benefitId },
    });
    useEffect(() => {
        currentSubscriptionBenefitVar(benefitId);
    });
    if (!data)
        return null;
    //@ts-ignore
    const benefit = data === null || data === void 0 ? void 0 : data.benefit;
    return (_jsxs("div", { className: "w-full max-w-xl", children: [_jsx(TitleBar, { title: `${(_b = (_a = benefit === null || benefit === void 0 ? void 0 : benefit.membershipTiers) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name} ` + (isWelcomeGift ? `Welcome Gift` : `Box`), action: WithfriendsAction.Memberships, primaryAction: WithfriendsAction.SaveSubscriptionBenefit, crumbs: [WithfriendsAction.Memberships], useSyncShopifyDataMutation: useSyncShopifyDataMutation }), _jsx(SubscriptionBenefit, { id: benefitId, welcomeGiftMembershipId: isWelcomeGift ? membershipId : null })] }));
};
export default EditSubscriptionBenefitScreen;
